import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { deleteRequest } from 'helpers/api';
import List from './panel/list';
import DeleteModal from './panel/delete_modal';

export default function RequirementsPanel({ newPath, requirements }) {
  const [requirementsList, setrequirementsList] = useState(requirements);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedRequirement, setSelectedRequirement] = useState();

  useEffect(() => {
    setrequirementsList(requirements);
  }, [requirements]);

  const hideDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedRequirement(null);
  };

  const deleteRequirement = (requirement) => {
    deleteRequest(requirement.updatePath)
      .then(() => {
        setrequirementsList(requirements.filter(req => requirement.id != req.id));
        hideDeleteModal();
      });
  };

  const handleOnDelete = (requirement) => {
    setShowDeleteModal(true);
    setSelectedRequirement(requirement);
  };

  const renderHeader = () => (
    <div className="d-flex justify-content-between align-items-center mb-4">
      <div className="fw-semibold">Requirements</div>
      <a className="text-primary" href={newPath}>
        + Add Requirement
      </a>
    </div>
  );

  return (
    <div>
      {renderHeader()}
      {<List requirements={requirementsList} onDelete={handleOnDelete} />}
      {
        selectedRequirement &&
        <DeleteModal
          requirement={selectedRequirement}
          shown={showDeleteModal}
          onClose={hideDeleteModal}
          onDelete={deleteRequirement}
        />
      }
    </div>
  );
}

RequirementsPanel.propTypes = {
  newPath: PropTypes.string.isRequired,
  requirements: PropTypes.array.isRequired
};
